"use client"

import { useEffect, useState } from "react"

export function useDebouncedValue(value: string, delayMs: number): string {
  const [debouncedValue, setDebouncedValue] = useState(value)

  useEffect(() => {
    if (debouncedValue === value) return
    const timeoutId = setTimeout(() => setDebouncedValue(value), delayMs)
    return () => clearTimeout(timeoutId)
  }, [debouncedValue, delayMs, value])

  return debouncedValue
}
